import Vue from "vue";

// What is playing in the floating mini player after you leave a video / episode screen (YouTube-style).
// item: { kind: "video" | "episode", id, src, poster, title, sub, time, isVideo, isMember, route, ref }
const state = Vue.observable({ item: null });

export default {
  state,
  minimize(item) { state.item = { ...item }; },
  close() { state.item = null; },
  /** True when this exact thing is the one in the mini player. */
  isMini(kind, id) { return !!state.item && state.item.kind === kind && state.item.id === id; },
  /** Helper for screens: minimize from a <video>/<audio> element if it is playing. Returns true if it did. */
  minimizeFrom(el, info) {
    if (!el || el.paused || el.ended || !info || !info.src) return false;
    state.item = { ...info, time: el.currentTime || 0 };
    return true;
  },
};